import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getTrongMuonThang(payload: {
  page?: number;
  limit?: number;
  cond?: any;
  donViId?: string;
  thang?: number;
  nam?: number;
  conId?: string
}) {
  const { page, limit, donViId,conId,thang, nam, cond } = payload;
  return axios.get(
    `${ip3}/diem-danh/trong-muon-thang/con/${conId}/don-vi/${donViId}/nam/${nam}/thang/${thang}`,
    {
      params: {
        page,
        limit,
        cond,
      },
    },
  );
}